/** True for a plain Escape press that should dismiss an overlay (not one that cancels an IME composition). */
export function isDismissEscape(e: Pick<KeyboardEvent, "key" | "defaultPrevented" | "isComposing" | "keyCode">): boolean {
  return e.key === "Escape" && !e.defaultPrevented && !e.isComposing && e.keyCode !== 229;
}

/**
 * Listen for Escape on `target`. `capture: true` is for the top-most layer (a Sheet over a Dialog): it
 * handles the key first and stops it, so the layers underneath, which listen in the bubble phase, stay open.
 */
export function onEscape(target: EventTarget, close: () => void, opts: { capture?: boolean } = {}): () => void {
  const capture = opts.capture ?? false;
  const handler = (ev: Event) => {
    const e = ev as KeyboardEvent;
    if (!isDismissEscape(e)) return;
    e.preventDefault();
    if (capture) e.stopImmediatePropagation();
    close();
  };
  target.addEventListener("keydown", handler, capture);
  return () => target.removeEventListener("keydown", handler, capture);
}
